// extracted by mini-css-extract-plugin
export default {"button":"_2rFad","mobile":"_33k9O","star":"_1PrgY","starFilled":"_349h3"};